module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av608-668171b4b86662ef5f03811e7697eb29.jpg";